import request from "@/api/request";

class SecurityService {
  static async getCaptcha(): Promise<boolean> {
    return await request.get("/security/captcha");
  }
}

export default SecurityService;
